import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

const About = () => {
  return (
    <section className="about">
      <SEO
        title="About Aimee Turner | ART Aesthetics & Skincare Widnes"
        description="Meet Aimee Turner, NHS Registered Nurse and founder of ART Aesthetics & Skincare in Widnes. Personalised, natural and safety-led skin treatment plans."
        path="/about"
      />
      <div className="about-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="page-title">About Me</h1>
          
          <div className="about-intro">
            <p className="intro-text">
              I'm Aimee, an NHS Registered Nurse and the founder of ART Aesthetics & Skincare.
            </p>
          </div>

          <div className="about-content">
            <div className="content-section">
              <p>
                I started this clinic because I genuinely care about doing things properly.
              </p>
              <p>
                I've had my own skin struggles over the years with acne and scarring, and I know how confusing 
                it can feel when you're trying to work out what actually works. That's why I take time to assess, 
                explain, and build treatment plans that make sense.
              </p>
              <p>
                My nursing background means safety and anatomy are second nature to me. But just as important is 
                how you feel when you're here.
              </p>
            </div>

            <div className="values-grid">
              <div className="value-card">
                <span className="value-icon">⏱️</span>
                <h3>You won't be rushed.</h3>
              </div>
              <div className="value-card">
                <span className="value-icon">🤝</span>
                <h3>You won't be pressured.</h3>
              </div>
              <div className="value-card">
                <span className="value-icon">✨</span>
                <h3>You definitely won't be over-treated.</h3>
              </div>
            </div>

            <div className="content-section">
              <p>
                Whether you're dealing with acne, wanting to improve your skin quality, or considering injectables, 
                my focus is always the same:
              </p>
              <ul className="focus-list">
                <li>Natural results.</li>
                <li>Healthy skin.</li>
                <li>You, still looking like you, but feeling more confident in your skin.</li>
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Acne Specialization Section */}
        <motion.div
          className="acne-specialization"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Struggling with Acne?</h2>
          <div className="acne-content">
            <p>
              Acne can be exhausting — especially when it feels like nothing is working.
            </p>
            <p>
              At ART Aesthetics & Skincare, acne treatment isn't about harsh quick fixes. It's about understanding 
              inflammation, barrier health, hormones, and lifestyle — and building a plan that supports 
              your skin properly.
            </p>
            <p>
              From personalised skin plans and targeted facials to regenerative treatments and gut health 
              testing, everything is structured around long-term stability.
            </p>
            <p className="emphasis">You don't have to keep guessing anymore.</p>
          </div>
        </motion.div>

        {/* What I Offer Section */}
        <motion.div
          className="what-i-offer"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">What I Can Offer You</h2>
          <div className="offer-content">
            <p>
              If you're feeling unsure about your skin, overwhelmed by options, or frustrated that nothing 
              seems to work properly, you're not alone.
            </p>
            <p>
              What I offer is clarity. I'll help you understand what's happening with your skin and why. 
              Then we'll create a plan that feels realistic, manageable, and tailored to you.
            </p>

            <div className="offer-list">
              <h3>I can help you:</h3>
              <ul>
                <li>✨ Build long-term skin health stability</li>
                <li>✨ Strengthen and repair your skin barrier</li>
                <li>✨ Improve texture, scarring, and early ageing concerns</li>
                <li>✨ Choose aesthetic treatments that enhance rather than overpower</li>
                <li>✨ Explore deeper root causes when needed</li>
              </ul>
            </div>

            <p className="closing-text">
              Everything is personalised. There are no rushed decisions and no pressure to commit to 
              something that doesn't feel right.
            </p>
            <p className="closing-text emphasis">
              You don't need to have it all figured out before you walk through the door.
            </p>
            <p className="closing-text emphasis">
              You just need to start.
            </p>
            <p className="closing-text">We'll take care of the rest, together.</p>
          </div>

          <div className="cta-section">
            <a 
              href="https://that-time.co.uk/art-aesthetics-skincare" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="cta-button primary"
            >
              Book Your Consultation
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
